import { useSyncExternalStore } from 'react'

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange)
  window.addEventListener('offline', onChange)
  return () => {
    window.removeEventListener('online', onChange)
    window.removeEventListener('offline', onChange)
  }
}

/**
 * Connectivity as an external store.
 *
 * `useSyncExternalStore` rather than `useState` + effects: it reads the real
 * value during render, so there is no frame where the UI claims "online"
 * because an effect hasn't run yet. Note `navigator.onLine` only proves a
 * local link exists, not that our API is reachable — treat it as a hint that
 * lets us warn early, never as proof a request will succeed.
 */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  )
}
